export default __webpack_public_path__ + "static/kite-5232b724e06d07df1a2e2f88263d005a.jpg";